import { render } from "./BaseAutoComplete.vue?vue&type=template&id=565645e4"
import script from "./BaseAutoComplete.vue?vue&type=script&lang=js"
export * from "./BaseAutoComplete.vue?vue&type=script&lang=js"

import "./BaseAutoComplete.vue?vue&type=style&index=0&id=565645e4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__